import WebGalleryActionBar from './WebGalleryActionBar';

export default WebGalleryActionBar;
